var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _rect5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path7, _line10, _line11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTram1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 214,
    viewBox: "0 0 643 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 24.1992,
    width: 537.6,
    height: 72,
    rx: 9.6,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 9.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.2 24.1992V96.1992",
    stroke: "black",
    strokeWidth: 9.6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.4 24.1992V96.1992",
    stroke: "black",
    strokeWidth: 9.6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 96.1984,
    width: 480,
    height: 86.4,
    rx: 4.8,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 9.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.808 177.799H629.005C650.605 177.799 624.205 206.599 614.619 207.416C605.033 208.233 521.005 208.999 504.205 207.416C495.876 206.631 502.757 199.346 504.209 192.199C505.686 184.928 501.808 177.799 501.808 177.799Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M501.808 177.799V172.999H493.733L497.591 180.092L501.808 177.799ZM504.205 207.416L503.754 212.195L503.754 212.195L504.205 207.416ZM504.209 192.199L499.505 191.243L499.505 191.243L504.209 192.199ZM629.005 172.999H501.808V182.599H629.005V172.999ZM503.754 212.195C512.447 213.014 537.943 213.211 562.136 213.116C586.336 213.021 609.989 212.628 615.027 212.199L614.211 202.633C609.664 203.021 586.509 203.42 562.098 203.516C537.68 203.612 512.762 203.401 504.655 202.637L503.754 212.195ZM615.027 212.199C617.184 212.015 619.327 211.124 621.163 210.129C623.08 209.089 625.058 207.717 626.964 206.178C630.762 203.11 634.607 199.109 637.442 195.049C638.861 193.017 640.107 190.855 640.947 188.692C641.766 186.583 642.344 184.099 641.963 181.59C641.544 178.84 640.02 176.45 637.435 174.913C635.069 173.505 632.14 172.999 629.005 172.999V182.599C631.269 182.599 632.241 182.993 632.527 183.163C632.633 183.226 632.593 183.225 632.528 183.128C632.464 183.032 632.463 182.974 632.472 183.034C632.503 183.237 632.501 183.922 631.998 185.217C631.517 186.457 630.701 187.934 629.571 189.553C627.307 192.795 624.105 196.147 620.932 198.709C619.353 199.985 617.864 200.997 616.588 201.689C615.229 202.425 614.45 202.613 614.211 202.633L615.027 212.199ZM501.808 177.799C497.591 180.092 497.591 180.091 497.59 180.09C497.59 180.09 497.589 180.089 497.589 180.088C497.588 180.087 497.587 180.085 497.587 180.084C497.585 180.082 497.584 180.08 497.584 180.078C497.582 180.075 497.581 180.073 497.581 180.074C497.581 180.074 497.585 180.08 497.591 180.093C497.605 180.119 497.631 180.169 497.667 180.243C497.739 180.39 497.853 180.628 497.99 180.943C498.266 181.577 498.629 182.502 498.954 183.616C499.623 185.91 500.029 188.662 499.505 191.243L508.913 193.154C509.865 188.465 509.071 184.017 508.17 180.928C507.71 179.351 507.196 178.04 506.792 177.11C506.588 176.643 506.41 176.267 506.276 175.996C506.209 175.86 506.153 175.75 506.111 175.668C506.089 175.627 506.071 175.593 506.057 175.565C506.05 175.552 506.043 175.54 506.038 175.53C506.035 175.525 506.033 175.52 506.03 175.516C506.029 175.514 506.028 175.512 506.027 175.51C506.027 175.509 506.026 175.508 506.026 175.508C506.025 175.506 506.024 175.505 501.808 177.799ZM499.505 191.243C499.245 192.524 498.71 193.942 498.004 195.612C497.38 197.085 496.475 199.069 495.949 200.789C495.475 202.339 494.755 205.281 496.293 208.046C497.977 211.073 501.187 211.953 503.754 212.195L504.655 202.637C503.058 202.487 504.005 202.162 504.682 203.379C505.213 204.333 504.743 204.86 505.129 203.598C505.464 202.505 506.03 201.279 506.845 199.351C507.577 197.621 508.447 195.447 508.913 193.154L499.505 191.243Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 489.8,
    y: 4.99922,
    width: 134.4,
    height: 19.2,
    rx: 4.8,
    fill: "black",
    stroke: "black",
    strokeWidth: 9.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.7998,
    y: 91.3984,
    width: 489.6,
    height: 96,
    rx: 9.6,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.278 177.799H216.2H291.678H494.6C516.2 177.799 489.8 206.599 480.215 207.416C472.953 208.035 325.162 207.716 253.939 207.525C182.716 207.716 34.9259 208.035 27.6639 207.416C18.0783 206.599 -8.32169 177.799 13.278 177.799Z",
    fill: "#9AFF6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M480.215 207.416L480.622 212.199L480.622 212.199L480.215 207.416ZM253.939 207.525L253.952 202.725L253.939 202.725L253.926 202.725L253.939 207.525ZM27.6639 207.416L27.2562 212.199L27.2562 212.199L27.6639 207.416ZM216.2 172.999H13.278V182.599H216.2V172.999ZM216.2 182.599H291.678V172.999H216.2V182.599ZM291.678 182.599H494.6V172.999H291.678V182.599ZM494.6 182.599C496.865 182.599 497.836 182.993 498.123 183.163C498.228 183.226 498.189 183.225 498.123 183.128C498.059 183.032 498.059 182.974 498.068 183.033C498.099 183.237 498.096 183.922 497.594 185.217C497.112 186.457 496.297 187.934 495.166 189.553C492.903 192.795 489.701 196.147 486.528 198.709C484.949 199.985 483.46 200.997 482.183 201.689C480.825 202.425 480.046 202.613 479.807 202.633L480.622 212.199C482.78 212.015 484.922 211.124 486.758 210.129C488.676 209.089 490.654 207.717 492.56 206.178C496.358 203.11 500.203 199.109 503.038 195.049C504.456 193.017 505.703 190.855 506.543 188.692C507.362 186.583 507.94 184.099 507.558 181.59C507.14 178.84 505.615 176.45 503.031 174.913C500.665 173.505 497.736 172.999 494.6 172.999V182.599ZM479.807 202.633C478.248 202.766 467.961 202.866 451.795 202.921C435.815 202.975 414.442 202.987 391.065 202.974C344.312 202.948 289.563 202.82 253.952 202.725L253.926 212.325C289.539 212.42 344.296 212.548 391.06 212.574C414.441 212.587 435.828 212.575 451.827 212.521C467.64 212.467 478.55 212.375 480.622 212.199L479.807 202.633ZM27.2562 212.199C29.3285 212.375 40.2385 212.467 56.0511 212.521C72.0501 212.575 93.438 212.587 116.819 212.574C163.582 212.548 218.34 212.42 253.952 212.325L253.926 202.725C218.316 202.82 163.566 202.948 116.813 202.974C93.4361 202.987 72.0634 202.975 56.0836 202.921C39.9174 202.866 29.6303 202.766 28.0716 202.633L27.2562 212.199ZM13.278 172.999C10.1425 172.999 7.21391 173.505 4.8476 174.913C2.26313 176.45 0.73834 178.84 0.320052 181.59C-0.0616137 184.099 0.516966 186.583 1.33565 188.692C2.17567 190.855 3.42217 193.017 4.8408 195.049C7.6757 199.109 11.5208 203.11 15.3189 206.178C17.225 207.717 19.2026 209.089 21.1203 210.129C22.9562 211.124 25.0987 212.015 27.2562 212.199L28.0716 202.633C27.8327 202.613 27.0533 202.425 25.6951 201.689C24.4187 200.997 22.9299 199.985 21.3505 198.709C18.1777 196.147 14.9755 192.795 12.7121 189.553C11.5817 187.934 10.7663 186.457 10.2849 185.217C9.78221 183.922 9.77984 183.237 9.81086 183.033C9.8199 182.974 9.81921 183.032 9.7553 183.128C9.68994 183.225 9.65008 183.226 9.75543 183.163C10.0423 182.993 11.0136 182.599 13.278 182.599V172.999Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5568,
    y: 4.99922,
    width: 470.4,
    height: 19.2,
    rx: 4.8,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 9.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 512.357,
    y1: 100.998,
    x2: 512.357,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 529.157,
    y1: 100.998,
    x2: 529.157,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 545.957,
    y1: 100.998,
    x2: 545.957,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 562.757,
    y1: 100.998,
    x2: 562.757,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 579.557,
    y1: 100.998,
    x2: 579.557,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 596.357,
    y1: 100.998,
    x2: 596.357,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 613.157,
    y1: 100.998,
    x2: 613.157,
    y2: 182.598,
    stroke: "black",
    strokeWidth: 4.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 456.2,
    y1: 74.6,
    x2: 590.6,
    y2: 74.6,
    stroke: "black",
    strokeWidth: 4.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 456.2,
    y1: 45.7992,
    x2: 590.6,
    y2: 45.7992,
    stroke: "black",
    strokeWidth: 4.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M552.48 194.599C553.365 192.287 555.545 177.799 561.674 177.799C567.803 177.799 570.392 192.944 570.868 194.599C571.343 196.254 570.393 201.799 567.803 201.799H555.119C552.903 201.799 551.594 196.91 552.48 194.599Z",
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 4.8,
    strokeLinecap: "square"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 480.2,
    y1: 2.6,
    x2: 494.6,
    y2: 2.6,
    stroke: "black",
    strokeWidth: 4.8
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 480.2,
    y1: 26.6,
    x2: 494.6,
    y2: 26.6,
    stroke: "black",
    strokeWidth: 4.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram1);
export default __webpack_public_path__ + "static/media/tram1.602f377b49b002eda1cbc8cb6f23aba2.svg";
export { ForwardRef as ReactComponent };